module.exports = __webpack_public_path__ + "static/img/8c8423d1f2c6e91ddc241f11bf01b12d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youshi_02.png
// module id = SvIU
// module chunks = 1